<template>
  <div class="match-detail__header-wrapper" v-if="!isMobileRealTime"
    :class="{
      'match-ended': data.matchState < 0
    }">
    <div class="match-detail__header-info__opponent">
      <Navigation
        :id="data.homeTeamId"
        :category="'team'"
        :name="data.homeTeamName"
        class="display-flex-center flex-1 justify-right"
      >
        <!-- <router-link  :to="{path:`/${currentLocale}/${currentSportType}/team/${data.homeTeamId}`}" class="display-flex-sb"> -->
        <div class="match-detail__header-team-container 1"
          :class="{
          'header-staring': data.matchState >= 0,
          'header-started': data.matchState > 0,
          'header-before-start-tomorrow': checkIfTomorrow(data.matchTime),
          'header-before-start-not-today-tomorrow': checkIfTomorrow(data.matchTime) === '' && data.matchState === 0
          }">
          <span
            class="penalty-compact-label right"
            v-if="
              data.homeTeamPenaltyScore &&
              data.homeTeamPenaltyScore > data.awayTeamPenaltyScore
            "
            >P</span
          >
          <div class="match-detail__header-info__home-name">
            {{ data.homeTeamName ? data.homeTeamName : "TBD" }}
          </div>
          <Icon
            :logoUrl="data.homeLogo"
            hasClass="match-detail-team-icon"
          ></Icon>
          
        </div>
      </Navigation>
      <!-- </router-link > -->
      <div class="match-detail__header-info-container">
        <div class="match-detail__header-info">
          <router-link :to="`/${currentLocale}/${currentSportType}/${data.leagueKey}/${data.leagueKey}-${data.leagueId}?leagueId=${data.leagueId}`">
            <div
            class="match-detail__header-info__match"
            v-if="data.leagueName !== null"
            >
            {{ data.leagueName }}
          </div>
        </router-link>
          <div class="match-detail__header-info__country">
            {{ data.country }}
          </div>
        </div>

        <div class="mr-2rem ml-2rem match-detail__header-info__score-wrapper">

          <div class="display-flex-center match-detail__header-info__score-section"
            v-if="data.matchState < 0 || data.matchState > 0">
          
            <div class="team-red-card-container">
              <div class="team-red-card" v-for="i in data.homeRed"></div>
            </div>

            <div :class="[ data.homeTeamScore >= 100 ? 
              'match-detail__header-info__score-100' : 
              'match-detail__header-info__score',]">
              {{ data.containExtraTime ? 
                data.homeTeamExtraTimeScore : 
                data.homeTeamScore }}
            </div>

            <div>-</div>

            <div :class="[ data.awayTeamScore >= 100 ? 
              'match-detail__header-info__score-100' : 
              'match-detail__header-info__score',]">
              {{ data.containExtraTime ? 
                data.awayTeamExtraTimeScore : 
                data.awayTeamScore }}
            </div>
            
            <div class="team-red-card-container">
              <div class="team-red-card" v-for="i in data.awayRed"></div>
            </div>
          </div>

          <div v-else class="display-flex-center match-detail__header-info__score-section match-time">
            {{ matchPrimaryStatus }}
          </div>
          <!--  && !data.matchStatus.includes(':') -->
          <div
            v-if="data.matchStatus && !data.awayTeamPenaltyScore"
            class="match-detail__header-info__match-status display-flex-center "
            :class="{
              'match-time-date-not-start': data.matchState === 0,
              'match-time-date-not-start-tomorrow': checkIfTomorrow(data.matchTime),
              'match-time-date-ended': data.matchState < 0,
              'match-time-date-matching': data.matchState > 0
            }"
          >
          <span v-if="data.matchState < 0">{{ matchPrimaryStatus }}</span>
          <span v-else >
            {{ checkIfTomorrow(data.matchTime) }}
          </span>
          
          </div>
          <div
            v-if="data.awayTeamPenaltyScore"
            class="match-penalty-score-wrapper"
          >
            PEN: {{ data.homeTeamPenaltyScore
            }}<span class="match-penalty-score-separator">-</span
            >{{ data.awayTeamPenaltyScore }}
          </div>
        </div>

        <div
          class="match-detail__header-info__penatly-score-wrapper"
          v-if="false"
        >
          <div
            class="match-detail__header-info__penatly display-flex-center"
            style="margin-bottom: 0"
            v-if="data.awayTeamPenaltyScore"
          >
            <Navigation
              :id="data.homeTeamId"
              :category="'team'"
              :name="data.homeTeamName"
              class="display-flex-sb relative"
            >
              <!-- <router-link  :to="{path:`/${currentLocale}/${currentSportType}/team/${data.homeTeamId}`}" class="display-flex-sb relative"> -->
              <div class="display-flex-center mr-1rem">
                <!-- style="width: 15rem" -->
                <!-- <div class="mr-1rem match-detail__header-info__home-name"></div> -->
                <div class="match-detail__header-info__penatly-label left">
                  <img
                    src="../../../static/images/label/label_pen_win.png"
                    v-if="data.homeTeamPenaltyScore > data.awayTeamPenaltyScore"
                  />
                </div>
                <!-- <Icon :category="'team'" :id=data.homeTeamId ></Icon> -->
              </div>
              <div class="match-detail__header-info__score">
                {{ data.homeTeamPenaltyScore }}
              </div>
              <!-- </router-link > -->
            </Navigation>
            <div>-</div>
            <Navigation
              :id="data.awayTeamId"
              :category="'team'"
              :name="data.awayTeamName"
              class="display-flex-sb relative"
            >
              <!-- <router-link  :to="{path:`/${currentLocale}/${currentSportType}/team/${data.awayTeamId}`}"  class="display-flex-sb relative"> -->
              <div class="mr-2rem match-detail__header-info__score">
                {{ data.awayTeamPenaltyScore }}
              </div>
              <div class="match-detail__header-info__penatly-label right">
                <img
                  src="../../../static/images/label/label_pen_win.png"
                  v-if="data.awayTeamPenaltyScore > data.homeTeamPenaltyScore"
                />
              </div>
              <!-- <div class="display-flex-center"> -->
              <!-- <div class="icon-league mr-1rem"></div> -->
              <!-- <div class="match-detail__header-info__away-name"></div> -->
              <!-- </div> -->
              <!-- </router-link>              -->
            </Navigation>
          </div>
          <div
            class="match-detail__header-info__penatly-title"
            v-if="data.awayTeamPenaltyScore"
          >
            {{ $t("PENALTY") }}
          </div>
        </div>

        <div
          class="match-detail__header-info__date"
          :class="'match-detail__header-info__date-' + currentLocale"
        >
          {{ dateFormat(data.matchTime) }}
        </div>
      </div>

      <!-- <router-link  :to="{path:`/${currentLocale}/${currentSportType}/team/${data.awayTeamId}`}"  class="display-flex-sb"> -->
      <Navigation
        :id="data.awayTeamId"
        :category="'team'"
        :name="data.awayTeamName"
        class="display-flex-center flex-1 justify-left"
      >
        <div class="match-detail__header-team-container 2"
        :class="{
          'header-staring': data.matchState >= 0,
          'header-started': data.matchState > 0,
          'header-before-start-tomorrow': checkIfTomorrow(data.matchTime),
          'header-before-start-not-today-tomorrow': checkIfTomorrow(data.matchTime) === '' && data.matchState === 0
          }">
          <span
            class="penalty-compact-label left"
            v-if="
              data.homeTeamPenaltyScore &&
              data.awayTeamPenaltyScore > data.homeTeamPenaltyScore
            "
            >P</span
          >
          <Icon
            :logoUrl="data.awayLogo"
            hasClass="match-detail-team-icon"
          ></Icon>
          <div class="match-detail__header-info__away-name">
            {{ data.awayTeamName ? data.awayTeamName : "TBD" }}
          </div>
        </div>
        <!-- </router-link>    -->
      </Navigation>
    </div>

    <!--  v-if="Object.keys(winRate).length > 0" -->
    <!-- <ScoreInfoWinRate :winRate="winRate" :detailOdds="detailOdds"></ScoreInfoWinRate> -->
    <!-- <div v-show="data.containLiveStream" class="w-100">
      <video
        id="videoLiveRef"
        class="video-js vjs-default-skin w-100"
        controls
        autoplay
      ></video>
    </div> -->
  </div>
  <div class="match-summary-container">
    <div class="goal-list" v-if="data.matchState < 0">
      <div class="goal-item left">
        <div class="goal-child" v-for="(i,index) in matchSummary.homeGoalEvents">
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
        </div>
      </div>
      
      
      <IconMode>
        <template #default="{ index }">
          <img src="@static/images/icons/aspn_icon/match_info/football.png" v-if="['lightWeb','lightWebapp'].includes(index)" class="goal-icon" />
          <img src="@static/images/icons/aspn_icon/match_info/football_dark.png" v-else-if="['darkWeb','darkWebapp'].includes(index)" class="goal-icon" />
        </template>
      </IconMode>

      <!-- <img src="../../../static/images/icons/aspn_icon/match_info/football.png"
        class="goal-icon" /> -->
      <div class="goal-item">
        <div class="goal-child" v-for="(i,index) in matchSummary.awayGoalEvents">
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
        </div>
      </div>
    </div>
    
    <div class="match-yellowred-list" v-if="isShowYellowRed">
      <div class="match-yellowred-item left">
        <div v-for="(i,index) in matchSummary.homeYellowRedEvents" 
          class="match-yellowred-child">
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
          <div class="player__row--item--yellow-card"
            v-if="i.eventType === 'yellowcard'"></div>
          <div class="player__row--item--red-card"
            v-if="i.eventType === 'redcard'"></div>
          <div class="player__row--item--red-card"
            v-if="i.eventType === 'yellowred'"></div>
        </div>
      </div>
      <div class="match-yellowred-item">
        <div v-for="(i,index) in matchSummary.awayYellowRedEvents" 
          class="match-yellowred-child">
          <div class="player__row--item--yellow-card"
            v-if="i.eventType === 'yellowcard'"></div>
          <div class="player__row--item--red-card"
            v-if="i.eventType === 'redcard'"></div>
          <div class="player__row--item--red-card"
            v-if="i.eventType === 'yellowred'"></div>
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
        </div>
      </div>
    </div>

    <div class="btn-view-all-card" 
      @click="isShowYellowRed = !isShowYellowRed" 
      v-if="hasYellowRed">
      {{ isShowYellowRed ? 
        $t('HIDE_ALL_CARD') :
        $t('VIEW_ALL_CARD') 
      }}
      <IconMode>
        <template #default="{ index }">
          <img src="@static/images/icons/icon_arrow_down_black.png" v-if="['lightWeb','lightWebapp'].includes(index)" class="arrow-icon"
            :class="{
              'show': isShowYellowRed
            }" />
          <img src="@static/images/icons/icon_arrow_down_white.png" v-else-if="['darkWeb','darkWebapp'].includes(index)" class="arrow-icon"
            :class="{
              'show': isShowYellowRed
            }" />
        </template>
      </IconMode>
    </div>

  </div>
</template>

<script>
import ScoreInfoWinRate from "@/components/matchDetail/ScoreInfoWinRate.vue";

import { mapGetters, mapActions } from "vuex";
import config from "@/js/config.js";
import { data } from "jquery";

export default {
  components: {
    ScoreInfoWinRate,
  },
  props: {
    data: {
      type: Object,
    },
    winRate: {
      type: Object,
      default: {},
    },
    detailOdds: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters(["currentLocale", "currentSportType","isMobileRealTime"]),
    hasYellowRed() {
      if(this.matchSummary.homeYellowRedEvents && this.matchSummary.awayYellowRedEvents) {
        let homeList = this.matchSummary.homeYellowRedEvents
        let awayList = this.matchSummary.awayYellowRedEvents
        if(homeList.length === 0 && awayList.length === 0) {
          return false
        }
        return true
      }
    }
    
  },
  watch: {
    data: {
      deep: true,
      handler(newVal, oldVal) {
        this.dateFormat();
        this.updateMatchStatus();
      },
    },
  },

  data() {
    return {
      matchDateDay: "",
      footballMatchStatusFullText: config.footballMatchStatusFullText,
      basketballMatchStatusFullText: config.basketballMatchStatusFullText,
      matchStatusFT: "FT",
      matchPrimaryStatus: "",
      cnLocaleList: config.cnLocaleList,
      matchSummary: {},
      isShowYellowRed: false
    };
  },
  mounted() {
    //this.dateFormat();
    this.getSummaryData()
    // this.playVideoLive();
  },

  methods: {
    ...mapActions([
      'getMatchDetailScoreCard'
    ]),
    updateMatchStatus() {
      if (this.data.matchStatus) {
        if (this.data.matchStatus === "Pen.") {
          if (this.currentSportType === "football")
            this.matchPrimaryStatus =
              this.footballMatchStatusFullText[this.matchStatusFT];
        } else {
          let keysArr;
          if (this.currentSportType === "football")
            keysArr = Object.keys(this.footballMatchStatusFullText);
          else if (this.currentSportType === "basketball")
            keysArr = Object.keys(this.basketballMatchStatusFullText);
          if (keysArr.includes(this.data.matchStatus)) {
            if (this.currentSportType === "football")
              this.matchPrimaryStatus =
                this.footballMatchStatusFullText[this.data.matchStatus];
            else if (this.currentSportType === "basketball") {
              if (
                [
                  "Q1",
                  "Q2",
                  "Q3",
                  "Q4",
                  "TBD",
                  "Interr.",
                  "Canc.",
                  "Postp.",
                ].includes(this.data.matchStatus)
              ) {
                this.matchPrimaryStatus = this.data.matchStatus;
              } else {
                this.matchPrimaryStatus =
                  this.basketballMatchStatusFullText[this.data.matchStatus];
              }
            }
          } else {
            this.matchPrimaryStatus = this.data.matchStatus;
          }
        }
      }
    },
    dateFormat() {
      if (typeof this.data !== "undefined") {
        if (typeof this.data.matchTime !== "undefined") {
          let matchEnded = this.data.matchState < 0
          let result;
          let matchDate = new Date(this.data.matchTime);

          if (this.currentLocale === "vn") {
            result = `${this.$i18n.t(
              this.$tools.getFullDay(matchDate.getDay())
            )},
              ${matchDate.getDate()} tháng ${matchDate.getMonth() + 1} năm
              ${matchDate.getFullYear()} 
              
              ${ !matchEnded ? '' : 
                `
                ,${matchDate.getHours()} giờ 
                ${(matchDate.getMinutes() < 10 ? "0" : "") +
                  matchDate.getMinutes()
                } phút`
              }`
          } else if (this.cnLocaleList.includes(this.currentLocale)) {
            result = `${this.$i18n.t(this.$tools.getDay(matchDate.getDay()))}, 
                ${matchDate.getDate()}日  
                ${matchDate.getMonth() + 1}月
                ${matchDate.getFullYear()}年
                ${ !matchEnded ? '' : `
                  ,${
                    (matchDate.getHours() < 10 ? "0" : "") + matchDate.getHours()
                  }:${
                    (matchDate.getMinutes() < 10 ? "0" : "") +
                    matchDate.getMinutes()
                  }
                `
                }
                `;
          } else {
            result = `${this.$i18n.t(this.$tools.getDay(matchDate.getDay()))},
                ${matchDate.getDate()} 
                ${this.$i18n.t(this.$tools.getMonth(matchDate.getMonth()))}
                ${matchDate.getFullYear()} 
                ${ !matchEnded ? '' : `
                  ,${
                    (matchDate.getHours() < 10 ? "0" : "") + matchDate.getHours()
                  }:${
                    (matchDate.getMinutes() < 10 ? "0" : "") +
                    matchDate.getMinutes()
                  }
                  `}
                `;
          }
          return result;
        }
      }
    },
    async getSummaryData() {
      const result = await this.getMatchDetailScoreCard({
        matchId: this.$route.params.matchId
      })
      if(result.errorCode === 0) {
        this.matchSummary = result.result
      }
    },
    checkIfTomorrow(dateString) {
      const inputDate = new Date(dateString);
      const today = new Date();

      // 获取今天的日期并设置时间为零点
      today.setHours(0, 0, 0, 0);

      // 创建明天的日期
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      // 检查输入日期是否与明天匹配
      if (
          inputDate.getFullYear() === tomorrow.getFullYear() &&
          inputDate.getMonth() === tomorrow.getMonth() &&
          inputDate.getDate() === tomorrow.getDate()
      ) {
          return this.$i18n.t('TOMORROW')
      } else {
          return "";
      }
  }
  },
};
</script>

<style>
.match-detail__content-container {
  min-height: 50vh;
}
.match-detail__header-wrapper {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  /* padding-top: 16px; */
  flex-direction: column;
  padding-bottom: 32px;
  /*2rem*/
}
.match-detail__header-wrapper.match-ended {
  padding-bottom: 24px;
}

.match-detail__header-info {
  text-align: center;
  margin-bottom: 4px;
}
.match-detail__header-info__match {
  color: var(--color-text-default-default);
  text-align: center;

  /* Body Base */
  font-size: var(--typography-body-size-large);
  font-style: normal;
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.64px;
  font-family: var(--weight-700);
}
.match-detail__header-info__country {
  color: var(--color-text-default-secondary);
  text-align: center;

  /* Body Small */
  font-family: var(--typography-body-font-family);
  font-size: var(--typography-body-size-small);
  font-style: normal;
  font-weight: var(--typography-body-font-weight-regular);
  line-height: 140%; /* 19.6px */
  letter-spacing: 0.64px;
  margin-bottom: 16px;
}
.match-detail__header-info__date {
  color: var(--color-text-default-secondary);
  text-align: center;

  /* Body Small */
  font-family: var(--typography-body-font-family);
  font-size: var(--typography-body-size-small);
  font-style: normal;
  font-weight: var(--typography-body-font-weight-regular);
  line-height: 140%; /* 19.6px */
  letter-spacing: 0.64px;
}
.match-detail__header-info__date-kh {
  font-family: "Khmer-400";
}
.match-detail__header-info__opponent {
  /* margin-bottom: 0.5rem; */
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}
.match-detail__header-info__match-status {
  color: var(--color-text-default-default);
  text-align: center;

  /* Body Strong */
  font-family: var(--typography-body-font-family);
  font-size: var(--typography-body-size-large);
  font-style: normal;
  font-family: var(--weight-600);
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.64px;
}
.match-detail__header-team-container {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  position: relative;
  padding-top: 11px;
  padding-bottom: 4px;
}
.match-detail__header-team-container img {
  width: 83.3px;
  height: 83.3px;
}
.header-staring {
  padding-top: 0;
  padding-bottom: 31px;
}
.header-started {
  padding-top: 0;
  padding-bottom: 0;
}
.header-before-start-tomorrow {
  padding-bottom: 0;
}
.header-before-start-not-today-tomorrow {
  padding-top: 21px;
  padding-bottom: 31px;
}
.match-detail__header-info__home-name {
  overflow: hidden;
  color: var(--color-text-default-default);
  text-align: center;
  text-overflow: ellipsis;

  /* Body Strong */
  font-size: var(--typography-body-size-large);
  font-style: normal;
  font-family: var(--weight-700);
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.64px;
}
.match-detail__header-info__home-name:hover {
  color: var(--primary-500);
}
.match-detail__header-info__away-name {
  overflow: hidden;
  color: var(--color-text-default-default);
  text-align: center;
  text-overflow: ellipsis;

  /* Body Strong */
  font-family: var(--typography-body-font-family);
  font-size: var(--typography-body-size-large);
  font-style: normal;
  font-family: var(--weight-700);
  font-weight: var(--weight-700);;
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.64px;
}
.match-detail__header-info__away-name:hover {
  color: var(--primary-500);
}
.match-detail__header-info__penatly {
  border-top: 0.1rem solid #35454d;
  margin-top: 0.6rem;
  padding-top: 0.5rem;
  /* width: 37.5rem; */
}
.match-detail__header-info__penatly-title {
  font-size: 0.875rem; /*0.7rem;*/
  color: var(--color-grey-light);
  margin-bottom: 1rem;
  line-height: 1.125rem;
  font-family: var(--weight-700);
}

.match-detail__header-info__penatly-label {
  top: 0.6rem;

  position: absolute;
  width: 2.3rem;
}
.match-detail__header-info__penatly-label.left {
  right: 3.4rem;
}
.match-detail__header-info__penatly-label.right {
  left: 3.4rem;
}

.penalty-compact-label {
  border-radius: var(--size-radius-100);
  background: var(--color-background-brand-default);
  padding: 2px 4px;
  font-size: 0.813rem;
  font-family: var(--weight-700);
  color: var(--color-tag-active-text);
  position: absolute;
}
.penalty-compact-label.left {
  top: -0.4rem;
  left: -0.6rem;
}
.penalty-compact-label.right {
  top: 24px;
  right: -0.6rem;
}
.match-penalty-score-wrapper {
  color: var(--color-text-default-secondary);
  text-align: center;

  /* Body Strong */
  font-family: var(--typography-body-font-family);
  font-size: var(--typography-body-size-large);
  font-style: normal;
  font-family: var(--weight-700);
font-weight: var(--weight-700);;
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.64px;
}
.match-penalty-score-separator {
  margin: 0 0.2rem;
}

.match-detail__header-info__score-wrapper {
  /* font-size: 1.375rem;
  font-family: var(--weight-700);
  width: 7.5rem; */
}
.match-detail__header-info__score-section {
  color: var(--color-text-default-default);

  /* Title Page */
  font-family: var(--typography-heading-font-family);
  font-size: var(--typography-heading-size-large);
  font-style: normal;
  font-family: var(--weight-700);
  line-height: 120%; /* 57.6px */
  letter-spacing: -0.64px;
  line-height: 120%;
}
.match-time {
  /* padding-top: 14px; */
}
.match-time-date-not-start {
  padding-top: 42px;
}
.match-time-date-not-start-tomorrow {
  padding-top: 16px;
}
.match-time-date-ended {
  padding-top: 16px;
}
.match-time-date-matching {
  height: 38.4px;
}
.match-detail__header-info__penatly-score-wrapper {
  font-size: 1.375rem;
  font-family: var(--weight-700);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.match-detail__header-info__score {
  width: 5.125rem; /*2rem*/
  text-align: center;
}
.match-detail__header-info__score-100 {
  width: 5.125rem; /*3rem*/
  text-align: center;
}
.match-detail__header-info__livevideo {
  width: 100%;
  height: auto;
}

</style>

<style scoped>
.match-summary-container {
  /* margin-top: 16px; */
  background-color: var(--color-background-default-tertiary);
  border-radius: 0 0 8px 8px;
}
.goal-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 96px;
  padding: 8px 0;
}
.goal-item {
  gap: 24px;
  font-size: 16px;
  color: var(--color-text-default-secondary);
  text-align: left;
  letter-spacing: .64px;
  font-style: italic;
  flex: 1;
	letter-spacing: 0.64px;
}
.goal-item.left {

  transform: rotateY(180deg);
  text-align: left;
}
.goal-child {
  
  display: inline-block;
  margin-right: 24px;
  margin-left: 0;
  margin-bottom: 4px;
}
.goal-item.left .goal-child {
  transform: rotateY(180deg);
  display: inline-block;
  margin-left: 24px;
  margin-right: 0;
}
.goal-icon {
  width: 24px;
  height: 24px;
}
.btn-view-all-card {
  display: flex;
  align-items: center;
  text-decoration: underline;
  padding: 8px 0;
  justify-content: center;
  cursor: pointer;
  color: var(--color-text-default-default);
}
.arrow-icon {
  margin-left: 8px;
  transform: rotate(0deg);
  transition: .5s;
}
.arrow-icon.show {
  transform: rotate(180deg);
  transition: .5s;
}
.player__row--item--red-card {
  width: 12px;
  height: 16px;
  border-radius: 4px;
  transform: rotate(-20deg);
  background-color: var(--card-red);
}
.player__row--item--yellowred-card {
  width: 12px;
  height: 16px;
  border-radius: 4px;
  transform: rotate(-20deg);
  background-image: url(../../../static/images/lineup/yellowred.png);
  background-size: 100%;
    background-repeat: no-repeat;
    transform: scale(1.7) translate3d(0, 2px, 10px);
}
.player__row--item--yellow-card {
  width: 12px;
  height: 16px;
  border-radius: 4px;
  transform: rotate(-20deg);
  background-color: var(--card-yellow);
}
.match-yellowred-list {
  display: flex;
  justify-content: center;
  gap: 32px;
  padding: 8px 0;
  
}
.match-yellowred-item {
  flex: 1;
}
.match-yellowred-item.left {
  justify-content: right;
}
.match-yellowred-child {
  gap: 8px;
  display: flex;
  font-size: 16px;
  color: var(--color-text-default-secondary);
  text-align: center;
  justify-content: left;
  letter-spacing: .64px;
  font-style: italic;
  margin-bottom: 8px;
}
.match-yellowred-item.left .match-yellowred-child {
  justify-content: right;
}
.match-yellowred-child:last-child {
  margin-bottom: 0;
}
.team-red-card-section {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.team-red-card-container {
  display: flex;
  justify-content: center;
  width: var(--size-icon-medium);
}
.team-red-card {
  background: var(--color-background-error-default);
  width: 9px;
  height: 12px;
  margin-right: 2px;
  border-radius: 1px;
  display: block;
  flex-shrink: 0;
}
.team-red-card:last-child {
  margin-right: 0;
}
.match-detail-team-icon {
  width: 83.3px;
  height: 83.3px;
}
.justify-left {
  justify-content: left;
  padding-right: 20px;
}
.justify-right {
  padding-left: 20px;
  justify-content: right;
}
.justify-left .match-detail__header-team-container,
.justify-right .match-detail__header-team-container {
  gap: 34.33px;
}

.justify-left .match-detail__header-info__away-name {
  text-align: left;
}

.justify-right .match-detail__header-info__home-name {
  text-align: right;
}
.justify-left .match-detail__header-info__away-name,
.justify-right .match-detail__header-info__home-name {
  font-size: 30px;
	line-height: 120%;
  font-family: var(--weight-600);
  line-height: 120%;
  letter-spacing: -0.64px;
}
.match-detail__header-info-container {
  min-width: 290.38px;
}

</style>